import useWindowSize from "../../hooks/sizeWindow";
import logoFc from "../../assets/PNG/logo20262.png";
import logoFc2 from "../../assets/PNG/logo20262.png";
import { Link, useNavigate } from "react-router-dom";
import pulgar from '../../assets/iconos/okey.png'

const AccesoDenegadoMuni = () => {
  const size = useWindowSize();

  const nav = useNavigate();

  return (
    <div className="">
      <section className="  d-flex flex-column align-items-center pb-3 text-white mx-auto  pt-5 " style={{ width: "100%", maxWidth: size.width < "500" ? "400px" : size.width < "700" ? "600px" : size.width < "1000" ? "700px" : "" }}>

        {
          size.width > "500"
            ?
            <img src={logoFc} alt="Logo-Fiesta-Confluencia" className="mb-3" style={{ width: "100%", maxWidth: size.width < "500" ? "400px" : size.width < "700" ? "500px" : "600px" }} />
            :
            <img src={logoFc2} alt="Logo-Fiesta-Confluencia" className="mb-3" style={{ width: "100%", maxWidth: size.width < "500" && "400px" }} />
        }

        <section className="d-flex flex-column align-items-center gap-4 " style={{ maxWidth: size.width < "500" ? "400px" : "500px" }}>


          <p className={`${size.width > "500" ? "parrafoSM" : "parrafoXSM"} noSelect bg-danger py-2 px-4`}>
            Usted pertenece a la planta política de la Municipalidad de Neuquén y no puede
            participar.
          </p>

          <div className="d-flex  align-items-center gap-5 ">
            <p className={`${size.width > "500" ? "parrafoSM" : "parrafoXSM"}  noSelect  w-100 px-4`}>
              Están excluidas de participar todas las personas que pertenezcan a la planta
              política del Municipio de la ciudad de Neuquén
            </p>
          </div>

          <img style={{ width: size.width > "500" ? "100px" : "100px", transform: " rotate(180deg)", zIndex: 1 }} src={pulgar} alt="sol-icon" />

          <button
            onClick={() => { nav('/') }}
            className={`px-4 py-2 ${size.width > "500" ? "parrafoXSM" : "parrafoXSM"} text-white mt-4 `}
            style={{
              backgroundColor: "#6D41A1",
              border: "none",
              // clipPath: "polygon(5% 5%, 95% 20%, 100% 83%, 11% 95%)",
            }}
          >
            VOLVER
          </button>

        </section>
      </section>

    </div>
  );
};
export default AccesoDenegadoMuni;
